import { useTranslation } from 'react-i18next';

import { GetCurrentAddOnsPayload } from '@mfe/shared/schema-types';

import ListItem from './easy-care-item';

const SubscribedEasyCareProduct = ({ product }: { product: GetCurrentAddOnsPayload }) => {
  const { t } = useTranslation('ShopAddons');
  return (
    <ListItem
      product={{
        name: product?.name ?? '',
        price:
          product?.discountDuration && product?.discountEndDate
            ? t('priceAfterPromotion', {
                oldPrice: product?.price,
                count: product?.discountDuration,
              })
            : t('cart.pricePerMonth', { price: Number(product?.price) }),
        description: product?.description ?? '',
        id: product?.productTypeId ?? '',
        oldPrice: Number(product?.price),
      }}
    />
  );
};

export default SubscribedEasyCareProduct;
